<mat-dialog-content class="mat-typography">
   <h1 mat-dialog-title>Ungespeicherte Änderungen</h1>
   <p>
       WARNUNG: Sie haben ungespeicherte Änderungen. Drücken Sie Abbrechen,<br> 
       um zu der Seite zurückzukehren und die Änderungen zu speichern oder <br>
       drücken Sie OK um die Änderungen zu verwerfen und die Seite zu verlassen.
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
   <button mat-button (click)="closeDialog(true)">OK</button>
   <button mat-button cdkFocusInitial (click)="closeDialog(false)">Abbrechen</button>
</mat-dialog-actions>
